import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Tiny "Deployed Mar 14, 14:02 · sha 7f3a91e" chip in the footer.
 * Pings /api/_meta/version once per session — silent on failure so missing
 * backend never breaks the UI. Lets you tell at a glance whether a deploy
 * actually shipped without hunting through DevTools.
 */
const RELATIVE_THRESHOLD_MS = 24 * 60 * 60 * 1000;

function formatStarted(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const ageMs = Date.now() - d.getTime();
  if (ageMs < 60_000) return "just now";
  if (ageMs < 3600_000) return `${Math.round(ageMs / 60_000)} min ago`;
  if (ageMs < RELATIVE_THRESHOLD_MS) return `${Math.round(ageMs / 3600_000)}h ago`;
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export default function BuildBadge() {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    let cancelled = false;
    api.get("/_meta/version")
      .then((r) => { if (!cancelled) setMeta(r.data); })
      .catch(() => { /* silent — old backend or offline */ });
    return () => { cancelled = true; };
  }, []);

  if (!meta) return null;
  const sha = (meta.sha || "unknown").slice(0, 8);
  const when = formatStarted(meta.started_at);
  return (
    <span data-testid="build-badge"
      title={`Deployed ${new Date(meta.started_at).toLocaleString()} · sha ${sha}`}
      className="inline-flex items-center gap-1.5 ms-2 px-2 py-0.5 rounded-full bg-white/[0.03] border border-white/5 text-[10px] text-zinc-500 hover:text-[#00E676] transition-colors">
      <span className="h-1.5 w-1.5 rounded-full bg-[#00E676] animate-pulse" />
      Deployed {when}
      <span className="text-zinc-600">· {sha}</span>
    </span>
  );
}
